export default from './promote-user-details';



// WEBPACK FOOTER //
// ./app/components/promote-user-details/index.js